export enum StoreKey {
// Add the Store Keys below
UserDetails = 'UserDetails',
UserPermission = 'UserPermission',
IntercoEleAccountDetails = 'IntercoEleAccountDetails',
SampleAdditionalFields = 'SampleAdditionalFields',
OrderAdditionalFields = 'OrderAdditionalFields',
SampleTemplateCode = 'SampleTemplateCode',
    SelectedMenuTabState = 'SelectedMenuTabState',
    SelectedOrderTemplate = 'SelectedOrderTemplate',
    PriorityLevels = 'PriorityLevels',
    SubmittedOrdersGridStoreData = 'SubmittedOrdersGridStoreData',
    PendingOrdersGridStoreData = 'PendingOrdersGridStoreData',
    FavouriteOrdersGridStoreData = 'FavouriteOrdersGridStoreData',
    ScheduledOrdersGridStoreData = 'ScheduledOrdersGridStoreData',
    ReadonlyRecipients = 'Recipients',
    eLIMSReadonlyRecipients = 'eLIMSRecipients',
    ReportTemplates = 'ReportTemplates',
    LabFormattedAddress = 'LabFormattedAddress',
    PickUpFormattedAddress = 'PickUpFormattedAddress',
    AccountFormattedAddress = 'AccountFormattedAddress',
    ProductApplicability = 'ProductApplicability'
}
